import React from 'react';
import { useId } from 'react-id-generator';
import BeeErrorLabel from './BeeErrorLabel';
import BeeInfoLabel from './BeeInfoLabel';
import BeePasswordInput from './BeePasswordInput';
import './BeeValidatedPasswordInput.scss';

type BeeValidatedPasswordInputProps = {
  id?: string;
  label?: string;
  errorLabel?: string | null;
  neutralLabel?: string | null;
  validLabel?: string | null;
  value?: string;
  disabled?: boolean;
  showPwStrength?: boolean;
  showHint?: boolean;
  formstate?: string;
  readOnly?: boolean;
  required?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export function BeeValidatedPasswordInput({
  id,
  label,
  errorLabel,
  neutralLabel,
  validLabel,
  value,
  disabled,
  showPwStrength,
  showHint,
  formstate,
  readOnly,
  required,
  onChange
}: BeeValidatedPasswordInputProps) {
  const genId = useId(1, 'bee-val-pw-input-')[0];
  const currentId = id ? id : genId;

  //classNames
  const labelClassNames = 'bee-validated-pw-input';

  const textSize = 'medium';
  const inputFormstate = formstate === 'none' ? 'neutral' : formstate;

  function change(e: React.ChangeEvent<HTMLInputElement>) {
    if (!disabled && onChange) {
      onChange(e);
    }
  }

  const renderLabel = () => {
    return (
      <div className={labelClassNames}>
        {formstate === 'error' && errorLabel ? (
          <BeeErrorLabel size={textSize} label={errorLabel} visible={true} />
        ) : formstate === 'valid' && validLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={validLabel}
            type={'valid'}
            visible={true}
          />
        ) : formstate === 'neutral' && neutralLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={neutralLabel}
            type={'neutral'}
            visible={true}
          />
        ) : null}
      </div>
    );
  };

  return (
    <div id={currentId}>
      <BeePasswordInput
        label={label}
        value={value}
        disabled={disabled}
        showPwStrength={showPwStrength}
        showHint={showHint}
        formstate={inputFormstate}
        readOnly={readOnly}
        required={required}
        onChange={(e) => change(e)}
      />
      {formstate !== 'none' && (errorLabel || neutralLabel || validLabel)
        ? renderLabel()
        : null}
    </div>
  );
}

export default BeeValidatedPasswordInput;
